<template>
  <section :class="$style.root">

    <RotatedHeading>
      <h3>Технологии</h3>
    </RotatedHeading>

    <div :class="$style.wrapper">
      <div :class="$style.left">

        <h2 :class="$style.subHeading">
          Мастерим проекты
          с&nbsp;помощью
        </h2>

        <ul :class="$style.techList">
          <li :class="$style.techItem">
            <router-link
              :class="$style.techInner"
              to="/join"
            >
              <svg
                v-svg
                :class="[$style.icon, $style.iconReact]"
                symbol="icon-react"
              />
              <p :class="$style.techText">React</p>
            </router-link>
          </li>
          <li :class="$style.techItem">
            <router-link
              :class="$style.techInner"
              to="/join"
            >
              <svg
                v-svg
                :class="[$style.icon, $style.iconAngularJs]"
                symbol="icon-angular-js"
              />
              <p :class="$style.techText">Angular</p>
            </router-link>
          </li>
          <li :class="$style.techItem">
            <router-link
              :class="$style.techInner"
              to="/join"
            >
              <svg
                v-svg
                :class="[$style.icon, $style.iconPython]"
                symbol="icon-python"
              />
              <p :class="$style.techText">Python</p>
            </router-link>
          </li>
          <li :class="$style.techItem">
            <router-link
              :class="$style.techInner"
              to="/join"
            >
              <svg
                v-svg
                :class="[$style.icon, $style.iconPhp]"
                symbol="icon-php"
              />
              <p :class="$style.techText">PHP</p>
            </router-link>
          </li>
          <li :class="$style.techItem">
            <router-link
              :class="$style.techInner"
              to="/join"
            >
              <svg
                v-svg
                :class="[$style.icon, $style.iconDotNet]"
                symbol="icon-dot-net"
              />
              <p :class="$style.techText">.NET</p>
            </router-link>
          </li>
          <li :class="$style.techItem">
            <router-link
              :class="$style.techInner"
              to="/join"
            >
              <svg
                v-svg
                :class="[$style.icon, $style.iconHtmlCss]"
                symbol="icon-html-css"
              />
              <p :class="$style.techText">HTML/CSS</p>
            </router-link>
          </li>
          <li :class="$style.techItem">
            <router-link
              :class="$style.techInner"
              to="/join"
            >
              <svg
                v-svg
                :class="[$style.icon, $style.iconSwift]"
                symbol="icon-swift"
              />
              <p :class="$style.techText">SWIFT</p>
            </router-link>
          </li>
          <li :class="$style.techItem">
            <router-link
              :class="$style.techInner"
              to="/join"
            >
              <svg
                v-svg
                :class="[$style.icon, $style.iconAndroid]"
                symbol="icon-android"
              />
              <p :class="$style.techText">Android</p>
            </router-link>
          </li>
          <li :class="$style.techItem">
            <router-link
              :class="$style.techInner"
              to="/join"
            >
              <svg
                v-svg
                :class="[$style.icon, $style.iconUnity]"
                symbol="icon-unity"
              />
              <p :class="$style.techText">Unity</p>
            </router-link>
          </li>
        </ul>
      </div>

      <div :class="$style.spacer"/>

      <div :class="$style.right">
        <base-slider
          ref="slick"
          :is-manual-init="true"
          :is-destroyed="!isSlickInit"
          :options="slickOpts"
          :class="$style.phrasesList"
        >
          <div :class="$style.phraseItem">
            <h4 :class="$style.phraseTitle">
              Очень Интересно
            </h4>
            <p :class="$style.phraseText">
              Это растущая команда профессионалов, которая меняет мир к&nbsp;лучшему. Мы&nbsp;помогаем клиентам решать нестандартные задачи, создаем и&nbsp;оптимизируем алгоритмы, используя современный арсенал технологий.
            </p>
          </div>
          <div :class="$style.phraseItem">
            <h4 :class="$style.phraseTitle">
              От&nbsp;нуля до&nbsp;бесконечности
            </h4>
            <p :class="$style.phraseText">
              В&nbsp;нашей команде есть дизайнеры, разработчики, архитекторы, проектировщики, менеджеры, инженеры, тестировщики&nbsp;— словом все, что нужно, чтобы сделать мечту реальностью. Мы&nbsp;развиваем идеи и&nbsp;вместе с&nbsp;нашими клиентами достигаем цели.
            </p>
          </div>
          <div :class="$style.phraseItem">
            <h4 :class="$style.phraseTitle">
              Раздвигаем границы
            </h4>
            <p :class="$style.phraseText">
              Для нас не существует географических или временных границ — наша команда представлена в Сочи, Екатеринбурге и Красноярске и свободно перемещается между городами, оставаясь на связи и эффективно работая из любой точки.
            </p>
          </div>
        </base-slider>
      </div>
    </div>
  </section>
</template>

<script>
import RotatedHeading from 'components/RotatedHeading';
import BaseSlider from './BaseSlider';

export default {
  name: 'HomeTechnologies',
  components: {
    RotatedHeading,
    BaseSlider,
  },
  data() {
    return {
      isSlickInit: false,
      slickOpts: {
        arrows: false,
        dots: true,
        dotsClass: this.$style.sliderDots,
      },
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize, { passive: true });
    this.initSlick();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initSlick() {
      if (window.innerWidth <= 767 && !this.isSlickInit) {
        this.isSlickInit = true;
        this.$refs.slick.create();
      } else if (window.innerWidth > 767 && this.isSlickInit) {
        this.isSlickInit = false;
        this.$refs.slick.destroy();
      }
    },
    handleResize() {
      this.initSlick();
    },
  },
};
</script>

<style lang="scss" module>
@import '~styles/variables';
@import '~styles/helpers';

.root {
  @extend %container;
  @extend %section;
}

.wrapper {
  @extend %content;
  display: flex;

  @include media('<=desktop') {
    display: block;
  }
}

.left {
  flex-basis: 580px;
}

.right {
  flex-basis: 400px;
}

.spacer {
  flex: 1;

  @include media('<=desktop') {
    display: none;
  }
}

.subHeading {
  @extend %heading;
  text-align: left;

  @include media('<=desktop') {
    text-align: center;
  }
}

.techList {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
}

.techItem {
  width: 33.33%;
  display: flex;
  justify-content: flex-start;
  padding: 40px 0;

  @include media('<=desktop') {
    justify-content: center;
  }

  @include media('<tablet') {
    padding: 20px 0;
  }
}

.techInner {
  text-align: center;
  cursor: crosshair;
  width: 60px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-decoration: none;
}

.techText {
  padding: 0;
  margin: 15px 0 0;
  font-size: 18px;
  line-height: 1.6;
  font-weight: 700;
  color: $gray-4;
  text-transform: uppercase;
  transition: color $transitions-delay $transitions-type;

  @include media('<tablet') {
    display: none;
  }
}

.icon {
  fill: $gray-4;
  transition: fill $transitions-delay $transitions-type;
}

.techInner:hover .techText {
  color: $blue;
}

.techInner:hover .icon {
  fill: $blue;
}

.iconReact {
  width: 62px;
  height: 56px;
}

.iconAngularJs {
  width: 53px;
  height: 57px;
}

.iconPython {
  width: 53px;
  height: 53px;
}

.iconPhp {
  width: 76px;
  height: 39px;
}

.iconDotNet {
  width: 87px;
  height: 35px;
}

.iconHtmlCss {
  width: 46px;
  height: 52px;
}

.iconSwift {
  width: 52px;
  height: 46px;
}

.iconAndroid {
  width: 50px;
  height: 59px;
}

.iconAws {
  width: 63px;
  height: 38px;
}

.iconUnity {
  width: 60px;
  height: 60px;
}

.phrasesList {
  padding-left: 40px;
  margin: 14px 0;

  @include media('<desktop') {
    margin-top: 40px;
  }

  @include media('<tablet') {
    margin: 40px 0 0;
    padding: 0;
  }
}

.phraseItem {
  position: relative;
  padding: 0 0 25px 35px;

  @include media('<tablet') {
    padding: 0;
    text-align: center;
  }

  &::before {
    content: '';
    position: absolute;
    z-index: $zidx-main;
    top: 10px;
    left: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: $blue;
  }

  &::after {
    content: '';
    position: absolute;
    top: 20px;
    left: 4px;
    width: 2px;
    height: 100%;
    background-color: $gray-7;
  }

  &:last-child::after {
    display: none;
  }
}

.phraseItem::before,
.phraseItem::after {
  @include media('<tablet') {
    display: none;
  }
}

.phraseTitle {
  margin: 0 0 12px;
  padding: 0;
  font-size: 24px;
  line-height: 1.25;
  color: $blue;
  font-weight: normal;

  @include media('<tablet') {
    @include set-fz-lh(20, 30);
    font-weight: 600;
  }
}

.phraseText {
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 1.56;
  color: $gray-dark;

  @include media('<tablet') {
    font-size: 15px;
    line-height: 23px;
    opacity: 0.8;
  }
}

.sliderDots {
  @extend %slickDots;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeTechnologies.vue